


























import { nextTick, Ref, ref, watch } from "vue-demi";
import BaseTable from "./BaseTable.vue";
import { useResult } from "@vue/apollo-composable";
import {
  DeletedMiddlemenQuery,
  useDeletedMiddlemenQuery,
} from "../../generated/backend";

export default {
  components: {
    BaseTable,
  },
  setup() {
    const table = ref(null);
    const fromDate = ref(null);
    const focus = ref(null);

    watch([fromDate, focus], () => {
      nextTick(() => {
        (table as any).value.searchChanged();
      });
    });

    return {
      table,
      fromDate,
      focus,
      headers: [
        {
          text: "Odstránené",
          value: "DeletedAt",
          sortable: true,
          searchable: false,
        },
        {
          text: "Meno",
          align: "start",
          value: "Name",
          searchable: true,
        },
        { text: "Telefón", value: "Phone", searchable: true },
        { text: "Popis", value: "Note", searchable: true },
        { text: "Odstránil", value: "deletedBy", searchable: true },
      ],
      query: useDeletedMiddlemenQuery,
      itemsGetter: (result: Ref<DeletedMiddlemenQuery>) =>
        useResult(result, [], (d) => d.deletedMiddlemen.nodes),
      totalCountGetter: (result: Ref<DeletedMiddlemenQuery>) =>
        useResult(result, 0, (d) => d.deletedMiddlemen.totalCount),
      reloadTable: () => (table as any).value.reload(),
    };
  },
};
